import { render } from "./DirectoryList.vue?vue&type=template&id=0a77a55e&scoped=true"
import script from "./DirectoryList.vue?vue&type=script&lang=js"
export * from "./DirectoryList.vue?vue&type=script&lang=js"

import "./DirectoryList.vue?vue&type=style&index=0&id=0a77a55e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a77a55e"]])

export default __exports__